import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

interface Product {
  id: string;
  name: string;
}

import { getEdgeFunctionUrl } from '@/utils/supabaseUrl';

const EDGE_FUNCTION_URL = getEdgeFunctionUrl('benchmark-webview');

export const useFMCGProducts = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const userId = searchParams.get('user_id');
        if (!userId) {
          console.error('No user_id found for fetching products');
          setProducts([]);
          setIsLoading(false);
          return;
        }

        // Fetch products from the edge function endpoint (bypasses RLS)
        const response = await fetch(`${EDGE_FUNCTION_URL}?user_id=${userId}&action=products`);
        
        if (!response.ok) {
          throw new Error(`Failed to fetch products: ${response.status}`);
        }
        
        const data = await response.json();
        setProducts(data || []);
      } catch (error) {
        console.error('Error fetching FMCG products:', error);
        setProducts([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProducts();
  }, [searchParams]);

  return { products, isLoading };
};
